
/**
 * Export `bool`
 */

module.exports = (function(){
  var el = document.createElement('canvas');
  return !! el.getContext;
})();



/*****************
 ** WEBPACK FOOTER
 ** ./~/component-spinner/supported.js
 ** module id = 20
 ** module chunks = 0
 **/